export default __webpack_public_path__ + "static/media/ea-img.c5ab143d.webp";